var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"Column",class:[_vm.$options.cols(_vm.props), _vm.data.class, _vm.data.staticClass],style:(_vm.props.grow && { flexGrow: _vm.props.grow })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }